module.exports = __webpack_public_path__ + "img/logement-nord.70e9e799.png";